import classNames from 'classnames';
import { CheckIcon, XIcon } from 'lucide-react';

import { usePricingPageContext } from '@/pricing/PricingPageContext';
import type * as Pricing from '@/pricing/types';

import styles from './Cell.module.scss';

interface Props {
    cell: Pricing.Cell | undefined;
}

export function Cell({ cell }: Props) {
    if (cell === undefined) {
        return null;
    }

    if (typeof cell === 'boolean') {
        return <BooleanCell value={cell} />;
    }

    if (typeof cell === 'object' && cell !== null) {
        return <PricingCell value={cell} />;
    }

    return <div className={styles.value}>{cell}</div>;
}

function PricingCell({ value }: { value: Pricing.PriceCell }) {
    const { currency } = usePricingPageContext();

    const text = value[currency];

    return <div className={styles.value}>{text}</div>;
}

function BooleanCell({ value }: { value: Pricing.CheckmarkCell }) {
    return (
        <div className={classNames(styles.value, styles.withCheckbox)}>
            {value ? (
                <div aria-label="Yes" className={classNames(styles.checkbox, styles.yes)}>
                    <CheckIcon className={styles.checkIcon} width={15} height={10} />
                </div>
            ) : (
                <div aria-label="No" className={classNames(styles.checkbox, styles.no)}>
                    <XIcon className={styles.crossIcon} width={15} height={10} />
                </div>
            )}
        </div>
    );
}
